import React, {Component} from 'react';
import {connect} from 'react-redux';
import '../style/userLayout.css';
import LayoutContent from "./layoutContent";
import LayoutFooterHOC from '../containers/General/layoutFooterHOC';
import AdminBurgerMenu from "./General/adminBurgerMenu";
import {logout} from "../actions/user";
import AdminHeaderHOC from "../containers/Layout/AdminHeaderHOC";
import {EnvironmentIndicator} from 'arag-ui-lib';
import { ENVANME, ENVCOUNTRY } from '../helpers/variables';

class AdminLayout extends Component {
    render() {
        return (
            <div>
                <div id="burgerMenuComponent2">
                    <AdminBurgerMenu logout={this.props.logout}/>
                </div>
                <div className="container user-layout-wrapper-size">
                    <AdminHeaderHOC />
                    <LayoutContent displayToba={this.props.displayToba} loggedInUserToba={this.props.loggedInUserToba}/>
                    <LayoutFooterHOC/>
                    <EnvironmentIndicator
                        country={ENVCOUNTRY}
                        envName={ENVANME}   
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        loggedInUserToba: state.user.loggedInUser.toba,
        displayToba: state.user.displayToba,
        username: state.user.loggedInUser.username,
        userRoles: state.user.loggedInUser.roles,
        notificationsIconCount: state.notifications.notificationsIconCount
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {
            dispatch(logout())
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminLayout);